'use client'

import { cn } from '@/lib/utils'
import { ColorMapperList } from '@/types/collection'
import { useEffect, useState } from 'react'

type Props = {
  onFilterChange: (value: string) => void
  value?: string
  colorsMapped?: ColorMapperList[]
}

export const FilterColors = ({
  onFilterChange,
  value,
  colorsMapped,
}: Props) => {
  const [selectedColors, setSelectedColors] = useState<string>(value || '')

  useEffect(() => {
    setSelectedColors(value || '')
  }, [value])

  const handleColorClick = (value: string) => {
    setSelectedColors(value)
    onFilterChange(value)
  }

  const linear =
    'linear-gradient(226.4deg, rgba(255, 26, 1, 1) 28.9%, rgba(254, 155, 1, 1) 33%, rgba(255, 241, 0, 1) 48.6%, rgba(34, 218, 1, 1) 65.3%, rgba(0, 141, 254, 1) 80.6%, rgba(113, 63, 254, 1) 100.1%)'

  return (
    <ul className='flex flex-wrap items-stretch gap-2'>
      {colorsMapped?.map((color, index) => (
        <ColorItem
          key={index}
          color={color.color_name}
          style={{
            background:
              color?.seo_alias === 'phoi-mau' ? linear : color.color_code,
          }}
          isActive={selectedColors === color.seo_alias}
          onClick={() => handleColorClick(color.seo_alias)}
        />
      ))}
    </ul>
  )
}

const ColorItem = ({
  color,
  className,
  isActive,
  onClick,
  style,
}: {
  color: string
  className?: string
  isActive: boolean
  onClick: () => void
  style?: React.CSSProperties
}) => {
  return (
    <li className='w-15 min-w-15'>
      <button
        onClick={onClick}
        className='group flex w-full flex-col items-center justify-start'
      >
        <span
          className={cn(
            'block h-6.5 w-6.5 rounded-full border bg-light',
            isActive
              ? 'border-primary-500'
              : 'border-gray-400 group-hover:border-primary-500',
            className
          )}
          style={style}
        ></span>
        <p
          className={cn(
            'mt-1 text-xs leading-3.5',
            isActive
              ? 'text-primary-500'
              : 'text-neutral-500 group-hover:text-primary-500'
          )}
        >
          {color}
        </p>
      </button>
    </li>
  )
}
